import React from 'react';
import { PaletteIcon, Code2Icon, ZapIcon, TargetIcon } from 'lucide-react';
export function WhatWeDoSection() {
  const pillars = [{
    icon: <PaletteIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-324" data-mp="2q8dg0ixw4jlg" />,
    title: 'World-class design',
    desc: 'Premium UI/UX that elevates your brand identity.'
  }, {
    icon: <Code2Icon className="w-6 h-6 text-[#D4AF37]" data-id="element-325" data-mp="3084a4jijgwl0" />,
    title: 'Enterprise development',
    desc: 'Clean, scalable code built for high-volume stores.'
  }, {
    icon: <ZapIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-326" data-mp="27ix0aodmwkkg" />,
    title: 'Performance optimization',
    desc: 'Lightning-fast load times that reduce bounce rates.'
  }, {
    icon: <TargetIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-327" data-mp="2gj29n42e1t19" />,
    title: 'Conversion psychology',
    desc: 'Data-driven layouts designed to maximize sales.'
  }];
  return <section className="section-padding bg-[#050505] relative" data-id="element-328" data-mp="1sqv5hiqf8hra">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-329" data-mp="1oqut03mvugmv">
        <div data-id="element-330" data-mp="1k599hr9msaq3">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-331" data-mp="1k3pu02vsu3pd">What We Do</h2>
          <p className="text-xl text-gray-400 leading-relaxed mb-8" data-id="element-332" data-mp="1p32ist68dkul">
            At Design Flow Digitals, we design and build powerful Shopify
            experiences for modern brands.
          </p>
          <p className="text-lg text-gray-400 leading-relaxed mb-10" data-id="element-333" data-mp="1ytx5fyne2mgk">
            From custom Shopify themes and apps to high-converting storefronts,
            we help businesses create fast, scalable and visually stunning
            ecommerce experiences.
          </p>

          {/* Stats Row */}
          <div className="flex gap-8 mb-10 pb-10 border-b border-white/10" data-id="element-334" data-mp="1b3jj8orhjhtw">
            <div data-id="element-335" data-mp="1g2mexilksbp7">
              <p className="text-4xl font-bold text-white mb-1" data-id="element-336" data-mp="1g35y12myp64t">
                99<span className="text-[#D4AF37]" data-id="element-337" data-mp="2miyg7sjp29p0">%</span>
              </p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-medium" data-id="element-338" data-mp="2miopu3uqm0is">
                Client Satisfaction
              </p>
            </div>
            <div className="w-[1px] bg-white/10" data-id="element-339" data-mp="rf0eib7eo9m6" />
            <div data-id="element-340" data-mp="rhwahtzp0o7z">
              <p className="text-4xl font-bold text-white mb-1" data-id="element-341" data-mp="mgp2bttn1n0s">
                2.5<span className="text-[#D4AF37]" data-id="element-342" data-mp="mggonzpoydoj">x</span>
              </p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-medium" data-id="element-343" data-mp="10f6q1rjjmzip">
                Avg. Conv. Lift
              </p>
            </div>
          </div>

          <div className="inline-block p-[1px] rounded-2xl bg-gradient-to-r from-[#F3E5AB]/30 via-[#D4AF37]/30 to-transparent shadow-[0_0_20px_rgba(212,175,55,0.1)]" data-id="element-344" data-mp="8oshmauaufef">
            <div className="bg-[#0a0a0a] rounded-2xl p-6" data-id="element-345" data-mp="3oe80od1uxea">
              <p className="text-xl font-medium text-white" data-id="element-346" data-mp="hif8pnnkauha">
                The result:{' '}
                <span className="text-gradient-gold font-bold" data-id="element-347" data-mp="cq3y9qv73qah">
                  Shopify stores that look beautiful and sell more.
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-348" data-mp="3h4vcfg0bc9lc">
          {pillars.map((pillar, index) => <div key={index} className="glass-card p-8 flex flex-col gap-4 transition-all duration-300 hover:-translate-y-2 hover:border-[#D4AF37]/30 hover:shadow-[0_10px_30px_-10px_rgba(212,175,55,0.15)] group" data-id="element-349" data-mp="36z3ucr91dssj" data-mpi={index}>
              <div className="w-14 h-14 rounded-full bg-[#D4AF37]/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300" data-id="element-350" data-mp="321andvzwsur7">
                {pillar.icon}
              </div>
              <div data-id="element-351" data-mp="3upgbmsq691vs">
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#D4AF37] transition-colors" data-id="element-352" data-mp="3upztyajqhsac">
                  {pillar.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-353" data-mp="3krsddstcxc8v">
                  {pillar.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}